// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"AdditionalInfoGallery_imageWrapper__THmZg","thumb":"AdditionalInfoGallery_thumb__d_OSW"};